import { Base } from '@studiometa/js-toolkit';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
gsap.registerPlugin(ScrollTrigger);

/**
 *  component
 */
export default class ScreenDesign extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'ScreenDesign',
    refs: ['video'],
  };

  breakpoints = ['xxs', 'xs'];

  /**
   * Get isMobile
   * @returns {boolean}
   */
  get isMobile() {
    return this.breakpoints.includes(this.$services.get('resized').breakpoint);
  }

  /**
   * mounted
   */
  mounted() {
    let end = '+=1650px';
    if (this.isMobile) {
      end = '+=1000px';
    }

    gsap.set(this.$refs.video, { scale: 0 });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: `#design-start`,
        toggleActions: 'play reverse play reverse',
        end,
      },
      onComplete: () => {
        this.$refs.video.currentTime = 0;
        this.$refs.video.play();
      },
      onReverseComplete: () => {
        this.$refs.video.pause();
        this.$refs.video.currentTime = 0;
      },
    });

    tl.to(
      this.$el,
      {
        opacity: 1,
        zIndex: 2,
        duration: 0.3,
        ease: 'power4.inOut',
      },
      0,
    );

    tl.to(
      this.$refs.video,
      {
        scale: 1,
        duration: 0.6,
        ease: 'expo.inOut',
      },
      0,
    );
  }
}
